// lib/pollJobStatus.ts
import { Session } from '@supabase/supabase-js';
import { fetchWithAuthJson } from '../utils/fetchWithAuth';

export const pollJobStatus = (
  campaignId: string,
  session: Session | null,
  setCampaign: React.Dispatch<React.SetStateAction<any>>,
  refreshCampaign: (preserveError?: string | null) => Promise<void>
) => {
  const interval = setInterval(async () => {
    try {
      const result = await fetchWithAuthJson(
        `/api/scrape-status/${campaignId}`,
        { method: 'GET' },
        session
      );

      if (result.status === 'completed') {
        refreshCampaign(result.data?.message ?? null); // refresh posts after job completion
        clearInterval(interval);
      } else if (result.status === 'failed') {
        setCampaign((prev: any) => ({
          ...prev,
          status: 'failed',
          error: result.data?.message ?? result.error ?? 'Job failed',
        }));
        clearInterval(interval);
      }
      // else still running, keep polling
    } catch (err) {
      console.error('Polling failed:', err);
      setCampaign((prev: any) => ({
        ...prev,
        status: 'failed',
        error: 'Polling failed. Please try again.',
      }));
      clearInterval(interval);
    }
  }, 4000);
};